import { createReducer } from "reduxsauce";

import ReducerRegister from "../ReducerRegister";
import DefaultService from "../../services/screens/DefaultService";
import { ActionTypes } from "../actionTypes/screens/DefaultActionTypes";
import AsyncActionReducers from "../AsyncActionReducers";

import UIDs from "../../UIDs";
import { ActionTypes as SessionActionTypes } from "../SessionRedux";

const uid = UIDs.screens.default;

//
// Actions
//
// Actions
const Actions = {
    loadAppAsync: () => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_APP_ASYNC });

            DefaultService.loadApp(
                (response) => {
                    dispatch(Actions.loadAppSuccess(response));
                },
                (error) => {
                    dispatch(Actions.loadAppFailure(error));
                }
            );
        };
    },

    loadAppSuccess: (data) => ({
        type: ActionTypes.LOAD_APP_SUCCESS,
        parentType: ActionTypes.LOAD_APP_ASYNC,
        data,
    }),

    loadAppFailure: (error) => ({
        type: ActionTypes.LOAD_APP_FAILURE,
        parentType: ActionTypes.LOAD_APP_ASYNC,
        error,
    }),
    // Clear networkToSync flag
    clearNetworkToSync: () => ({ type: ActionTypes.CLEAR_NETWORK_TO_SYNC }),
};

//
// Initial State
//
const INITIAL_STATE = { sessionLoaded: false, networkToSync: null };

//
// Reducers
//

// Reducer handlers for named functions
function handleTryLoadSession(state) {
    return { ...state, sessionLoaded: true };
}

function handleLogout(state) {
    return { ...state, sessionLoaded: false };
}

function handleNetworkToSync(state, action) {
    const { currentSchoolId, shortId } = action;
    return { ...state, networkToSync: shortId || currentSchoolId };
}

function handleClearNetworkToSync(state) {
    return { ...state, networkToSync: null };
}

// Use reduxsauce's createReducer to make it clearer for
// each action handler
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_APP_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_APP_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_APP_FAILURE]: AsyncActionReducers.failureReducer,
    [SessionActionTypes.TRY_LOAD_SESSION]: handleTryLoadSession,
    [SessionActionTypes.LOGOUT_SUCCESS]: handleLogout,
    [SessionActionTypes.CHANGE_NETWORK]: handleNetworkToSync,
    [ActionTypes.CLEAR_NETWORK_TO_SYNC]: handleClearNetworkToSync,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
